<template>
  <v-data-table
    :headers="cabecalhos"
    :items="props.horarios"
    dense
    hide-default-footer
  >
    <template #item.horario="{item}">
      {{ String(item.horario).substring(0, 5) }}
    </template>
  </v-data-table>
</template>

<script setup>
const props = defineProps({
  horarios: Array
});

const cabecalhos = [
  { text: 'Hora marcada', value: 'horario' },
  { text: 'Início', value: 'horario_inicio' },
  { text: 'Fim', value: 'horario_final' }
];
</script>

<style scoped>

</style>
